import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import Snackbar from 'material-ui/Snackbar'
import { dequeueNotification } from '../actions'

class NotificationQueue extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      notification: undefined,
    }
    this.timeoutId = undefined
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.notification !== nextProps.notification) {
      if (!this.state.notification && nextProps.notification) {
        this.setState({
          open: true,
          notification: nextProps.notification,
        })
      } else if (this.state.notification && nextProps.notification) {
        this.setState({
          open: false,
        })
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          this.setState({
            open: true,
            notification: nextProps.notification,
          })
        }, 300)
      } else {
        this.setState({
          open: false,
        })
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          this.setState({
            notification: undefined,
          })
        }, 400)
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId)
  }

  handleOnRequestClose = reason => {
    const { notification } = this.state
    if (reason !== 'clickaway' || notification.clickaway) {
      this.props.dequeueNotification()
    }
  }

  render() {
    const { notification, open } = this.state

    return (
      <Snackbar
        open={open}
        bodyStyle={get(notification, 'style')}
        autoHideDuration={get(notification, 'timeout', 1000)}
        onRequestClose={this.handleOnRequestClose}
        message={get(notification, 'message', '')}
      />
    )
  }
}

const mapStateToProps = state => ({
  notification: get(state.notificationQueue, '[0]'),
})

export default connect(mapStateToProps, {
  dequeueNotification,
})(NotificationQueue)



// WEBPACK FOOTER //
// ./src/common/NotificationQueue.js